import StickyNavPosition from '@models/enums/StickyNavPositionEnum';
import create from 'zustand';

type StickyNavPositions = StickyNavPosition.Top | StickyNavPosition.Bottom;

interface IStickyNavPositionState {
  readonly stickyNavPosition: StickyNavPosition;
  readonly setStickyNavPosition: (navPosition: StickyNavPositions) => void;
}

const useStickyNavPositionStore = create<IStickyNavPositionState>((set) => ({
  stickyNavPosition: StickyNavPosition.Top,
  setStickyNavPosition: (navPosition: StickyNavPositions) =>
    set({ stickyNavPosition: navPosition }),
}));

export default useStickyNavPositionStore;
